export default "__VITE_ASSET__CGISc1e1__"